import { render, staticRenderFns } from "./ItemSeparator.template.vue?vue&type=template&id=54d22a68&scoped=true&"
var script = {}
import style0 from "./ItemSeparator.template.vue?vue&type=style&index=0&id=54d22a68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d22a68",
  null
  
)

export default component.exports